import { render, staticRenderFns } from "./CreditosVenta.vue?vue&type=template&id=0108dcbe&scoped=true"
import script from "./CreditosVenta.vue?vue&type=script&lang=js"
export * from "./CreditosVenta.vue?vue&type=script&lang=js"
import style0 from "./CreditosVenta.vue?vue&type=style&index=0&id=0108dcbe&prod&lang=css"
import style1 from "./CreditosVenta.vue?vue&type=style&index=1&id=0108dcbe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0108dcbe",
  null
  
)

export default component.exports